<template>
  <div class="flex bg-gray-200">
    <div class="mx-auto text-gray-500 text-xs py-2">KOSTENLOSER VERSAND</div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>